import { ITimeBlockListing } from "../../../entities-generated/models/time-block/time-block-listing";

export class TimeBlockGroup
{
  constructor(public date: Date, public timeBlocks: ITimeBlockListing[]){}
}